import moment from 'moment';
import fields from "./fields.utils.js";


const schema_motor_bike = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "engine": {
        label: 'engine',
        type: 'number',
        value: '',
        required: true,

        placeholder: 'Engine'
    },
    "ncb_years_private": {
        label: 'Ncb Years',
        type: 'number',
        value: 0,
        required: true,

        placeholder: 'Ncb Years'
    },
    //Driver
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "licence_type": {
        label: "Licence type",
        type: 'select',
        value: '',
        options: [],
        required: true
    },
    "occupation_x_type": {
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
    },
    "conviction_x_type": {
        label: "Conviction Type",
        type: 'select',
        value: '',
        options: [],

        placeholder: 'Conviction Type'
    },
    "conviction_x_points": {
        label: "Conviction points",
        type: 'number',
        value: 0,

        placeholder: 'Conviction Points'
    },
    "conviction_x_ban": {
        label: "Conviction Ban",
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "has_criminal_convictions": {
        label: 'criminal convictions',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "owner": {
        label: 'Owner',
        type: 'select',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    "claim_x_type": {
        label: "Type",
        type: 'select',
        value: '',
        options: [],
        orderOptions: false,
        placeholder: 'Claim Type'
    },
    "claim_x_date": {
        label: "Date",
        type: 'date-mask',
        value: moment().format("DD/MM/YYYY"),

        placeholder: 'Claim Date'
    },
//policy
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,

        placeholder: 'Cover Date'
    },

    "cover_type": {
        label: 'Cover Type',
        type: 'select',
        value: '',
        options: [],
        required: true,

        placeholder: 'Cover Type'
    },
    "cover_duration": {
        label: 'Cover Duration in months',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    ...fields.marketing,
    "vrm": {
        type: 'vehicle-lookup',
        value: '',
        placeholder: 'Registration Number'
    },
    "make": {
        label: 'make',
        type: 'select',
        value: '',
        options: [],
        placeholder: 'Make',
    },
    "model": {
        label: 'Model',
        type: 'text',
        value: '',
        placeholder: 'Model',
    },
    "year": {
        label: 'What is the vehicle manufacture year?',
        type: 'number',
        value: '',
        placeholder: 'Year'
    },
    ...fields.title,
    ...fields.cross_selling,
    overnight_location: {...fields.overnight_location},
    mileage: {...fields.mileage},
};
export default schema_motor_bike;
